import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import * as S from '../scss/theme';
import fnc from "../mymod/commFunction";
import './MyRoom_acaTec.scss';
import HongButton from "../comm/HongButton";
import HeaderTitle from "../comm/HeaderTitle";  

import { useNavigate } from "react-router-dom";
import { setActiveLink, setIsLoggedIn, setUserInfo, setUserName } from "../reduxToolkit/reduxIgong";
import { setSelectedUserInfo, setVideoEduKind } from "../reduxToolkit/reduxIgong";
// import { setSelectedStCode, setSelectedUserName } from "../reduxToolkit/reduxIgong";

const MyRoom_acaTec = () => {
    const userInfo = useSelector((state) => state.reduxIgong.userInfo);
    const videoEduKind = useSelector((state) => state.reduxIgong.videoEduKind);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(-1);



    function handleRegAcaStu() {
        navigate('/regAcaStu');
    }

    function handleAssessment() {
        navigate('/assessment');
    }

    function handleAssessResult() {

        dispatch(setSelectedUserInfo(userInfo));
        navigate('/assess/all/testNmApp');

    }

    function handleAssessmentStuLink() {
        navigate('/assess/assess_link_stu');
    }

    function fncBack() {
        navigate(-1);
    }

     function handleVideEdu() {
            dispatch(setVideoEduKind('tec'));
            dispatch(setSelectedUserInfo(userInfo));
            navigate('/videoEdu');
    }
        

    //=============================================
    return (
        <S.Section>
            <HeaderTitle title={' '} onBackClick={fncBack} direction={1} />
            <div className="MyRoom_acaTec">
                <div className='wrap-main'>
                <section className='sec-main1'>        
                    <article className="art1">
                        <p className='title'>마이룸 (학원 : 강사)</p>
                        <HongButton className="btn h-btn-dark" onClick={handleAssessment}>학부모용 | 코칭진단</HongButton>    
                        <HongButton className="btn h-btn-dark" onClick={handleAssessResult}>코칭진단 결과</HongButton>
                        <HongButton className="btn h-btn-red" onClick={handleRegAcaStu}>학생등록</HongButton>
                        <HongButton className="btn h-btn-red" onClick={handleAssessmentStuLink}>학생용 | 코칭진단 및 결과</HongButton>
                        <HongButton className="btn h-btn-green" onClick={handleVideEdu}>프로코치 교사인증 프로그램</HongButton>
                    </article>

                </section>

              
            
                </div>
            </div>
        </S.Section>
    );
};

export default MyRoom_acaTec;
